import { IS_DEV_MODE } from "./core/Global";

const { App } = require("./core/App");
const dev = IS_DEV_MODE; // this forces globals import
export const _App = new App();
//# sourceMappingURL=main.js.map
